import { Col, Layout, Row } from 'antd'
import React from 'react'

import scienceLogo from '../../../static/image/scienceLogo.png'
import courseLogo from '../../../static/image/courseLogo.png'
import modelCubeLogo from '../../../static/image/modelCubeLogo.png'

import * as constants from '../../../constants/constants'
const { Footer } = Layout
interface Props {}

export const PageFooter: React.FC<Props> = (props: Props) => {
  const ENV = process.env
  const hasBrandLinks = ENV.REACT_APP_COURSE || ENV.REACT_APP_SCIENCE || ENV.REACT_APP_MODELCUBE
  const footerColSpan = hasBrandLinks && ENV.REACT_APP_FOOTER_NUM ? 12 : 24

  return (
    <Footer
      style={{
        paddingTop: 16,
        paddingBottom: 16,
        backgroundColor: '#f9f8fd',
        width: '100%',
        color: '#8c8c8c',
        textAlign: 'center',
        bottom: 0,
        borderTop: '1px solid #eee',
      }}
    >
      <Row
        style={{
          width: '100%',
          maxWidth: 1000,
          margin: '0 auto',
          padding: '0 20px',
          rowGap: 12,
        }}
        justify="center"
        align="middle"
      >
        {hasBrandLinks && (
          <Col xs={24} md={footerColSpan}>
            <Row
              justify="center"
              align="middle"
              style={{ minHeight: 48, gap: '28px' }}
            >
              {ENV.REACT_APP_SCIENCE && (
                <Col>
                  <div
                    style={{ cursor: 'pointer', opacity: 0.7, transition: 'opacity 0.2s' }}
                    onMouseEnter={(e) => (e.currentTarget.style.opacity = '1')}
                    onMouseLeave={(e) => (e.currentTarget.style.opacity = '0.7')}
                    onClick={() => {
                      window.open(ENV.REACT_APP_SCIENCE_URL)
                    }}
                  >
                    <img
                      title="爱数科"
                      alt="logo"
                      src={scienceLogo}
                      width={110}
                      height={28}
                    />
                  </div>
                </Col>
              )}
              {ENV.REACT_APP_COURSE && (
                <Col>
                  <div
                    style={{ cursor: 'pointer', opacity: 0.7, transition: 'opacity 0.2s' }}
                    onMouseEnter={(e) => (e.currentTarget.style.opacity = '1')}
                    onMouseLeave={(e) => (e.currentTarget.style.opacity = '0.7')}
                    onClick={() => {
                      window.open(ENV.REACT_APP_COURSE_URL)
                    }}
                  >
                    <img
                      title="爱数课"
                      alt="logo"
                      src={courseLogo}
                      width={110}
                      height={28}
                    />
                  </div>
                </Col>
              )}
               {ENV.REACT_APP_MODELCUBE&&<Col>
                  <div
                    style={{ cursor: 'pointer', opacity: 0.7, transition: 'opacity 0.2s' }}
                    onMouseEnter={(e) => (e.currentTarget.style.opacity = '1')}
                    onMouseLeave={(e) => (e.currentTarget.style.opacity = '0.7')}
                    onClick={() => {
                      window.open(ENV.REACT_APP_MODELCUBE_URL)
                    }}
                  >
                    <img
                      title="modelCube"
                      alt="modelCube"
                      src={modelCubeLogo}
                      width={110}
                      height={28}
                    />
                  </div>
                </Col>}
            </Row>
          </Col>
        )}
        {ENV.REACT_APP_FOOTER_NUM && (
          <Col xs={24} md={footerColSpan}>
            <div
              style={{
                minHeight: 48,
                lineHeight: '1.6',
                margin: '0 auto',
                fontSize: 13,
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                flexWrap: 'wrap',
                gap: '4px',
              }}
            >
              <span style={{ fontFamily: 'Arial' }}>©</span> {new Date().getFullYear()} {' '}
              数据实验楼（iDataCoding）{' '}
              <a
                style={{ color: '#8c8c8c', transition: 'color 0.2s' }}
                href="https://beian.miit.gov.cn/"
                onMouseEnter={(e) => (e.currentTarget.style.color = '#4f46e5')}
                onMouseLeave={(e) => (e.currentTarget.style.color = '#8c8c8c')}
              >
                京ICP备2021001687号-4
              </a>
            </div>
          </Col>
        )}
      </Row>
    </Footer>
  )
}

export default PageFooter
